import React, { useMemo } from 'react';
// icons
import { FiCalendar } from 'react-icons/fi';

// components
import BasicChip from '../../components/display/chips/basicChip';
// components
import AampeTooltip from '../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// helpers
import { getFormulaScheduleTimeText } from '../../helpers/formulaHelpers';

// models
import {
    ApprovedFormulaState,
    FormulaStatus,
    FormulaStatusData,
} from '../../models/formula.model';

interface StyledProps {
    activeState: FormulaStatus | ApprovedFormulaState;
}

interface CurrentStateProps {
    isControlledFormula: boolean;
    startDate: string;
    endDate: string;
    activeState: FormulaStatus | ApprovedFormulaState;
    timezone?: string;
}

const FormulaStatusView: React.FC<React.PropsWithChildren<CurrentStateProps>> =
    ({ activeState, startDate, endDate, isControlledFormula, timezone }) => {
        const dateText = useMemo<string>(
            () =>
                getFormulaScheduleTimeText(
                    isControlledFormula,
                    startDate,
                    endDate,
                    timezone,
                ),
            [startDate, endDate, isControlledFormula, timezone],
        );

        if (!activeState) return null;

        return (
            <AampeTooltip
                title={
                    <TooltipTitle>
                        <CalendarIcon />
                        {dateText}
                    </TooltipTitle>
                }
            >
                <div>
                    <StyledBasicChip
                        activeState={activeState}
                        title={FormulaStatusData[activeState]?.label}
                    />
                </div>
            </AampeTooltip>
        );
    };

const StyledBasicChip = styled(BasicChip).withConfig({
    shouldForwardProp: (prop) => !['activeState'].includes(prop),
})<StyledProps>(({ activeState }) => ({
    backgroundColor: FormulaStatusData[activeState]?.color,
    color: aampeTheme.colors.white,
    fontSize: '16px',
    padding: aampeTheme.spacing(1, 2),
}));

const CalendarIcon = styled(FiCalendar)(() => ({
    color: 'inherit',
    marginRight: aampeTheme.spacing(1),
}));

const TooltipTitle = styled.div({
    padding: aampeTheme.spacing(1),
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
});

export default FormulaStatusView;
